module.exports = __webpack_public_path__ + "static/img/img16.4a5cd2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/113/img16.jpg
// module id = PdEa
// module chunks = 1